/**
 * Scroll To Bottom Mixin
 *
 * Provides scroll-to-bottom functionality for chat interfaces.
 * Requires a messages container element with ref="messagesContainer".
 *
 * Usage:
 *   import scrollToBottom from '@/mixins/scrollToBottom.js'
 *
 *   export default {
 *     mixins: [scrollToBottom],
 *     // In template:
 *     // <div ref="messagesContainer" class="messages-container">
 *     //   <!-- messages content -->
 *     // </div>
 *   }
 *
 * Methods provided:
 *   - scrollToBottom(smooth = true) - Scroll to the bottom of the container
 *   - scrollToBottomNextTick(smooth = true) - Scroll after next DOM update
 */
export default {
  methods: {
    /**
     * Scroll to the bottom of the messages container
     * @param {boolean} smooth - Use smooth scrolling (default: true)
     */
    scrollToBottom(smooth = true) {
      const container = this.$refs.messagesContainer;
      if (container) {
        if (smooth) {
          container.scrollTo({
            top: container.scrollHeight,
            behavior: "smooth",
          });
        } else {
          // Instant scroll - set scrollTop directly
          container.scrollTop = container.scrollHeight;
        }
      }
    },

    /**
     * Scroll to bottom on next tick (useful after DOM updates)
     * @param {boolean} smooth - Use smooth scrolling (default: true)
     */
    scrollToBottomNextTick(smooth = true) {
      this.$nextTick(() => {
        this.scrollToBottom(smooth);
      });
    },
  },
};
